'use strict';
require('../modules/esnext.array-buffer.detached');
require('../modules/esnext.array-buffer.transfer');
require('../modules/esnext.array-buffer.transfer-to-fixed-length');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/array-buffer-transfer.js
// module id = 1000
// module chunks = 31